<template>
  <transition-group name="slide-down" tag="div" class="notifications-list">
    <notification-item
      v-for="notification in updateNotifications"
      :key="notification.id"
      :notification="notification"
    />
  </transition-group>
</template>

<script setup>
import { useConfirmUpdate } from 'src/composables/app/useConfirmUpdate'
import NotificationItem from 'src/components/common/NotificationItem.vue'

const { updateNotifications } = useConfirmUpdate()
</script>

<style lang="scss" scoped>
.notifications-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}

.slide-down-enter-from {
  opacity: 0;
  transform: translateY(-20px);
}

.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
